import { store } from "./index.js";
// var Parse = require("parse");
import Parse from "@/main.js";
export default {
  state: {
    loading: false,
    error: null,
    success: null,
    departments: [],
    router: {},
    // new
    sectionGlobalCategories: { articles: [], surveys: [], maps: [], files: [] },
    allDepartments: [],
    currentCategory: null,
    currentDepartment: null,
    searchedUsers: [],

    searchResult: [],
    searchError: "",
    isSearching: false,
    sectionFilters: {},
    departmentCategories: []
  },

  getters: {
    loading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    success(state) {
      return state.success;
    },

    getShareInfo(state) {
      return state.shareInfo;
    },

    getRouter(state) {
      return state.router;
    },

    getAllDepartments(state) {
      return state.allDepartments;
    },

    getSectionDepartmentCategories(state, rootGetters) {
      return (section, department) => {
        let sectionCategories = [];
        if (department && department.categories) {
          sectionCategories = department.categories.filter(
            category =>
              category.get("type") == section.substring(0, section.length - 1)
          );
        }
        return sectionCategories;
      };
    },

    getSectionGlobalCategories(state) {
      return section => {
        return state.sectionGlobalCategories[section];
      };
    },

    getSectionFilters(state) {
      return section => {
        return state.sectionFilters[section];
      };
    },

    getAllFilters(state) {
      return state.sectionFilters;
    },

    getCurrentDepartment(state, rootGetters) {
      var currentDepartment;
      if (rootGetters.user) {
        var route_scope = state.router.currentRoute.params.scope;
        var roles = rootGetters.user.get("roles");
        var departments_for_search = roles.includes("admin")
          ? rootGetters.getAllDepartments
          : rootGetters.getUserDepartmentsFromState;

        if (route_scope == "global") {
          return null;
        } else {
          if (departments_for_search) {
            departments_for_search.forEach(department => {
              if (department && department.get("slug") == route_scope) {
                currentDepartment = department;
              }
            });
          }
        }
      }
      return currentDepartment;
    },

    getCurrentCategory(state, rootGetters) {
      var cat = null;
      if (rootGetters.user) {
        var route_scope = state.router.currentRoute.params.scope;
        var route_category = state.router.currentRoute.params.category;
        var route_name_full = state.router.currentRoute.matched[0].name;
        var section = route_name_full.substring(0, route_name_full.length - 1);

        var roles = rootGetters.user.get("roles");
        var departments_for_search = roles.includes("admin")
          ? rootGetters.getAllDepartments
          : rootGetters.getUserDepartmentsFromState;

        if (route_scope == "global") {
          if (state.sectionGlobalCategories[section]) {
            state.sectionGlobalCategories[section].forEach(category => {
              if (category.get("slug") == route_category) {
                cat = category;
              }
            });
          }
        } else {
          if (departments_for_search) {
            departments_for_search.forEach(department => {
              if (department && department.get("slug") == route_scope) {
                if (department.categories) {
                  department.categories.forEach(category => {
                    if (
                      category.get("type") == section &&
                      category.get("slug") == route_category
                    ) {
                      cat = category;
                    }
                  });
                }
              }
            });
          }
        }
      }

      return cat;
    },

    getSearchedUsers(state) {
      return state.searchedUsers;
    },

    getSearchedResult(state) {
      return state.searchResult;
    },

    getSearchError(state) {
      return state.searchError;
    },

    isSearchingContent(state) {
      return state.isSearching;
    }
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    setSuccess(state, payload) {
      state.success = payload;
    },
    clearSuccess(state) {
      state.success = null;
    },

    setSectionGlobalCategories(state, payload) {
      state.sectionGlobalCategories = payload;
    },
    setAllDepartments(state, payload) {
      state.allDepartments = payload;
    },

    setDepartmentCategories(state, payload) {
      state.departmentCategories = payload;
    },

    setRouter(state, payload) {
      state.router = payload;
    },

    setCurrentCategory(state, payload) {
      state.currentCategory = payload;
    },

    setCurrentDepartment(state, payload) {
      state.currentDepartment = payload;
    },

    searchedUsers(state, payload) {
      state.searchedUsers = payload;
    },

    setSearchedResult(state, payload) {
      state.searchResult = payload;
    },

    setSearchError(state, payload) {
      state.searchError = payload;
    },

    isSearching(state, payload) {
      state.isSearching = payload;
    },

    setSectionFilters(state, payload) {
      state.sectionFilters = payload;
    }
  },

  actions: {
    setSearchedResult({ commit }, payload) {
      commit("setSearchedResult", payload);
    },

    setSearchError({ commit }, payload) {
      commit("setSearchError", payload);
    },

    isSearching({ commit }, payload) {
      commit("isSearching", payload);
    },

    clearError({ commit }) {
      commit("clearError");
    },

    setError({ commit }, payload) {
      commit("setError", payload);
    },

    clearSuccess({ commit }) {
      commit("clearSuccess");
    },

    setSuccess({ commit }, payload) {
      commit("setSuccess", payload);
    },

    setLoading({ commit }, payload) {
      commit("setLoading", payload);
    },

    sendNewNotification({ commit }, payload) {
      let notif = {
        to: payload.to,
        from: store.getters.user,
        type: payload.type,
        action: payload.action,
        seen: false
      };

      if (payload.type == "survey") notif.surveyRef = payload.ref;
      if (payload.type == "submission") {
        notif.surveyRef = payload.ref;
        notif.submissionId = payload.submissionId;
      }
      if (payload.type == "article") notif.articleRef = payload.ref;
      if (payload.type == "file") notif.fileRef = payload.ref;
      if (payload.type == "map") notif.mapRef = payload.ref;

      new DB.Notification(notif)
        .insert()
        .then(s => {})
        .catch(e => {});
    },

    async fetchSidebarReports({ commit, rootGetters }) {
      const query = new Parse.Query("Filter");
      query.descending("createdAt");
      query.equalTo("show_in_sidebar", true);

      if (
        !rootGetters.user.get("roles").includes("admin") &&
        !rootGetters.user.get("roles").includes("guest")
      ) {
        query.equalTo("department", rootGetters.user.get("department").id);
      }

      const results = await query.find();

      let sectionFilters = {
        survey: [],
        article: [],
        file: [],
        map: []
      };

      results.forEach(filter => {
        // filter.get("department_slug") != "global"
        if (filter.get("department_slug") == "global") {
          sectionFilters[filter.get("type")].push(filter);
        } else {
          if (rootGetters.user.get("department")) {
            // department-based
            if (
              rootGetters.user.get("department").get("slug") ==
              filter.get("department_slug")
            )
              sectionFilters[filter.get("type")].push(filter);
          } else {
            // for admin
            sectionFilters[filter.get("type")].push(filter);
          }
        }
        // if (rootGetters.user.get("department") && filter.get("department_slug") != "global") {
        //   if (rootGetters.user.get("department").get("slug") == filter.get("department_slug"))
        //     if (!sectionFilters[filter.get("type")])
        //       sectionFilters[filter.get("type")] = [];
        //     else sectionFilters[filter.get("type")].push(filter);
        // } else {
        //   if (!sectionFilters[filter.get("type")])
        //     sectionFilters[filter.get("type")] = [];
        //   sectionFilters[filter.get("type")].push(filter);
        // }
      });

      commit("setSectionFilters", sectionFilters);
    },

    // new
    async fetchGlobalCategories({ commit, rootGetters }) {
      var conditions = [];
      var roles = rootGetters.user.get("roles");
      conditions.push(new Parse.Query("Category").equalTo("department", null));
      if (!roles.includes("admin") || !roles.includes("guest")) {
        var temp_or_conditions = [
          new Parse.Query("Category").notEqualTo("objectId", "")
        ];
        if (roles.includes("surveys"))
          temp_or_conditions.push(
            new Parse.Query("Category").equalTo("type", "survey")
          );
        if (roles.includes("articles"))
          temp_or_conditions.push(
            new Parse.Query("Category").equalTo("type", "article")
          );
        if (roles.includes("files"))
          temp_or_conditions.push(
            new Parse.Query("Category").equalTo("type", "file")
          );
        if (roles.includes("maps"))
          temp_or_conditions.push(
            new Parse.Query("Category").equalTo("type", "map")
          );

        conditions.push(Parse.Query.or(...temp_or_conditions));
      }
      var mainQuery = Parse.Query.and(...conditions);
      mainQuery.descending("createdAt");
      var results = await mainQuery.find();

      let sectionGlobalCategories = {};
      if (results) {
        results.forEach(category => {
          if (!sectionGlobalCategories[category.get("type")])
            sectionGlobalCategories[category.get("type")] = [];
          sectionGlobalCategories[category.get("type")].push(category);
        });
      }
      commit("setSectionGlobalCategories", sectionGlobalCategories);
    },

    async fetchDepartments({ commit }) {
      let departments = [];
      const query = new Parse.Query("Department");
      const fetched_departments = await query.find();

      if (fetched_departments) {
        fetched_departments.forEach(async department => {
          const category_query = new Parse.Query("Category");
          category_query.equalTo("department", department);
          const result = await category_query.find();
          department.categories = result;
          departments.push(department);
        });
      }
      commit("setAllDepartments", departments);
    },

    async fetchDepartmentCategories({ commit, rootGetters, dispatch }) {
      var departments = rootGetters.getUserDepartmentsFromState;
      if (departments) {
        for (let i = 0; i < departments.length; i++) {
          const department = departments[i];
          var query = new Parse.Query("Category");
          query.equalTo("department", department);
          var result = await query.find();
          department.categories = result;
        }
      }

      dispatch("setUserDepartments", departments);
    },

    setRouter({ commit }, payload) {
      commit("setRouter", payload);
    },

    async fetchUsers({ commit, state, rootGetters }, payload) {
      var fetchedUsers = [];
      var conditions = [];
      var route_scope = state.router.currentRoute.params.scope;

      if (rootGetters.user) {
        conditions.push(
          new Parse.Query("User").containedIn("roles", payload.roles)
        );

        conditions.push(
          Parse.Query.or(
            new Parse.Query("User").matches("email", `^.*${payload.query}.*`),
            new Parse.Query("User").matches("name", `^.*${payload.query}.*`)
          )
        );

        if (route_scope == "global") {
          // payload.department == null
        } else {
          // payload.department != null
          if (!payload.roles.includes("guest")) {
            conditions.push(
              new Parse.Query("User").equalTo("departments", payload.department)
            );
          }
        }

        var mainQuery = Parse.Query.and(...conditions);
        fetchedUsers = await mainQuery.find();

        commit("searchedUsers", fetchedUsers);
      }
      return fetchedUsers;
    },

    async rejectObject({ commit, state, rootState }, payload) {
      payload.self.VaModal.confirm({
        title: payload.self._("Alert"),
        message: payload.self._(
          "Please make sure if you want to reject the selected " +
            payload.object.className.toLowerCase()
        ),
        type: "warning",
        onConfirm() {
          payload.self.$store.commit("setLoading", true);
          payload.object.set("status", "rejected");
          payload.object.set(
            "approvalBy",
            makePointer("User", rootState.auth.user.id)
          );
          payload.object
            .save()
            .then(async updated => {
              // payload.self.articleStatus = 'rejected'
              // payload.self.viewedArticle = updated
              // await payload.self.sendNewNotification({ to: updated.uploadedBy, type: 'article', action: 'rejected', ref: updated })
              // payload.self.$router.go(-1)
              payload.self.articleKey = Date.now();
              // payload.self.$router.replace({ name: 'survey', params: { surveyId: updated.id.substring(updated.id.lastIndexOf('/') + 1), category: updated.category.name, categoryId: updated.category.id.substring(updated.category.id.lastIndexOf('/') + 1) } })
              payload.self.$store.commit("setLoading", false);
              payload.self.$notify({
                group: "foo",
                text: payload.self._(
                  payload.object.className + " was rejected"
                ),
                duration: 4000,
                position: "top left",
                type: "error"
              });
            })
            .catch(e => {
              payload.self.$store.commit("setLoading", false);
            });
        }
      });
    },

    async approveObject({ commit, state, rootState }, payload) {
      payload.self.VaModal.confirm({
        title: payload.self._("Alert"),
        message: payload.self._(
          "Please make sure if you want to approve the selected " +
            payload.object.className.toLowerCase()
        ),
        type: "warning",
        onConfirm() {
          payload.self.$store.commit("setLoading", true);
          payload.object.set("status", "approved");
          payload.object.set(
            "approvalBy",
            makePointer("User", rootState.auth.user.id)
          );
          payload.object
            .save()
            .then(async updated => {
              // payload.self.articleStatus = 'rejected'
              // payload.self.viewedArticle = updated
              // await payload.self.sendNewNotification({ to: updated.uploadedBy, type: 'article', action: 'rejected', ref: updated })
              // payload.self.$router.go(-1)
              payload.self.articleKey = Date.now();
              // payload.self.$router.replace({ name: 'survey', params: { surveyId: updated.id.substring(updated.id.lastIndexOf('/') + 1), category: updated.category.name, categoryId: updated.category.id.substring(updated.category.id.lastIndexOf('/') + 1) } })
              commit("setLoading", false);
              payload.self.$notify({
                group: "foo",
                text: payload.self._(
                  payload.object.className + " was approved"
                ),
                duration: 4000,
                position: "top left",
                type: "error"
              });
            })
            .catch(e => {
              payload.self.$store.commit("setLoading", false);
            });
        }
      });
    }
  }
};
